import { environment } from '../../../environments/environment';
import { setApiBaseUrl } from './api.config';
import { setBusinessKey } from './tenant.config';

interface AppConfigFile {
  apiBaseUrl?: string;
  businessKey?: string;
}

/**
 * Loads optional public/app-config.json so API URL and tenant key can be changed
 * after deploy without rebuilding.
 */
export async function loadAppConfig(): Promise<void> {
  try {
    const configFile = environment.appConfigFile || 'app-config.json';
    const response = await fetch(configFile, { cache: 'no-store' });
    if (!response.ok) {
      return;
    }
    const config = (await response.json()) as AppConfigFile;
    if (config.apiBaseUrl?.trim()) {
      setApiBaseUrl(config.apiBaseUrl);
    }
    if (config.businessKey?.trim()) {
      setBusinessKey(config.businessKey);
    }
  } catch {
    // Keep environment default when the file is missing or invalid.
  }
}
